// react components
import React, {
    useEffect,
    useState,
} from 'react'
import axios from 'axios'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import Select from 'react-select'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
} from 'data'

// portfolio
import {
    CustomCSSProperties,
    MainIdNameSerializer,
} from 'serializers/site'

// services
import {
    axiosErrorHandlerSite,
    getAxiosHeadersSite,
} from 'services'

// props
type SelectListInputSiteProps = {
    apiUrl?: string | undefined
    disabled?: boolean
    error: string | undefined
    label: string
    multi?: boolean
    name: string
    onChange: (e: any) => void
    options?: MainIdNameSerializer[]
    placeholder?: string
    stylesLabel?: CustomCSSProperties | undefined
    value: any
}

// main
export const SelectListInputSite: React.FC<SelectListInputSiteProps> = React.memo(({
    apiUrl,
    disabled,
    error,
    label,
    multi,
    name,
    onChange,
    options,
    placeholder,
    stylesLabel,
    value,
}) => {

    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        setValue(value)
    }, [value])

    useEffect(() => {
        if (options) setNewOptions(options)
    }, [options])

    const dispatch = useDispatch()
    const reduxAuth = useSelector((state: defaultReduxState) => state.reduxAuth)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const deviceType = reduxModalSite.deviceType

    const [newOptions, setNewOptions] = useState<MainIdNameSerializer[]>(options || [])
    const [newValue, setValue] = useState<any>(value)

    function onInputChange(value: any) {
        try {
            if (value === newValue) return
            setValue(value)
            onChange({
                name: name,
                value: value,
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'SelectListInputSite',
                'onInputChange',
            ))
        }
    }

    function getData() {
        try {
            if (options) return
            if (!apiUrl) return
            const listArray: MainIdNameSerializer[] = []
            axios({
                headers: getAxiosHeadersSite(reduxAuth, reduxModalSite, dispatch),
                method: 'get',
                url: apiUrl,
            })
                .then((response) => {
                    if (Array.isArray(response.data)) {
                        response.data.map((val) => {
                            listArray.push(val)
                            return false
                        })
                        setNewOptions(listArray)
                    }
                })
                .catch((error) => {
                    axiosErrorHandlerSite({
                        apiUrl,
                        component: 'SelectListInputSite',
                        dispatch,
                        error,
                        reduxAuth,
                        reduxModalSite,
                        reference: 'getData',
                    })
                })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'SelectListInputSite',
                'getData',
            ))
        }
    }

    const lightCustomStyles = {
        control: (provided: any, state: any) => ({
            ...provided,
            borderRadius: '8px',
        }),
        input: (provided: any, state: any) => ({
            ...provided,
            color: 'black',
        }),
        menu: (provided: any, state: any) => ({
            ...provided,
            borderRadius: '8px',
            zIndex: 9999,
        }),
        menuList: (provided: any, state: any) => ({
            ...provided,
            zIndex: 9999,
        }),
        option: (provided: any, state: any) => ({
            ...provided,
            color: state.isSelected ? '#8ea1ff' : 'black',
        }),
        singleValue: (provided: any, state: any) => ({
            ...provided,
            color: 'black',
        }),
    }

    return (
        <div className={`select-list-input-site ${deviceType}`}>
            {label && (
                <div className='slis-form-label' >
                    <label
                        className='slis-form-label-wrap'
                        htmlFor={name}
                    >
                        <span style={stylesLabel}>
                            {label}
                        </span>
                    </label>
                </div>
            )}
            <Select
                closeMenuOnSelect={!multi}
                getOptionLabel={option => option.name}
                getOptionValue={option => `${option.id}`}
                isClearable={false}
                isDisabled={disabled}
                isMulti={multi}
                name={name}
                menuPlacement='top'
                onChange={onInputChange}
                options={newOptions}
                placeholder={placeholder || ''}
                styles={lightCustomStyles}
                value={newValue}
            />
            {error && <span className='slis-error'>{error}</span>}
        </div>
    )
})
